export type SocialPlatform = 'steam' | 'discord' | 'youtube' | 'instagram' | 'twitch' | 'tiktok' | 'bluesky' | 'x';

export const socialLinks: { label: string; href: string; platform: SocialPlatform }[] = [
  {
    label: 'Steam',
    href: 'https://store.steampowered.com/developer/kadderagames',
    platform: 'steam',
  },
  {
    label: 'YouTube',
    href: 'https://www.youtube.com/@kodzimk',
    platform: 'youtube',
  },
  {
    label: 'Instagram',
    href: 'https://www.instagram.com/kadderagames/',
    platform: 'instagram',
  },
  {
    label: 'X',
    href: 'https://x.com/kodzimk',
    platform: 'x',
  },
];

export const team = [
  {
    id: 1,
    name: 'kodzimk',
    role: 'Founder / Developer',
    description: '',
    image: '/me.png',
  },
  {
    id: 2,
    name: 'Arnur',
    role: 'Video Editor',
    description: '',
    image: '/Gemini_Generated_Image_k3ovgnk3ovgnk3ov.png',
  },
];
